import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpService } from "../http.service";
import { LogoImageContractService } from "../interfaces/logo-image-contract.service";

@Injectable({
  providedIn: "root"
})
export class LogoImageOnlineService extends HttpService implements LogoImageContractService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  deleteLogo(): Observable<unknown> {
    throw new Error("Method not implemented.");
  }

  getLogoImage(): Observable<string | null> {
    const endpoint = super.getEndpoint("logo");
    return this.http.get<string>(endpoint, { withCredentials: super.getWithCredentialsOption() }).pipe(
      catchError((error, caught) => {
        if (error && error.status === 404) {
          return of(null);
        }

        throw error;
      })
    );
  }

  uploadLogoImage(file: File): Observable<void> {
    const formData = new FormData();
    formData.append("formData", file, file.name);

    const endpoint = super.getEndpoint("logo");

    return this.http.put<void>(endpoint, formData, { withCredentials: super.getWithCredentialsOption() });
  }
}
